/**
 * Remove o sufixo do JID do WhatsApp para exibição
 * @param {string} jid - JID completo (ex: "5511999999999@s.whatsapp.net", "123456@lid", "123@g.us")
 * @returns {string} - Apenas os dígitos do número
 */
export const formatPhoneNumber = (jid) => {
  if (!jid) return "";

  // Remove @s.whatsapp.net, @lid, @g.us e qualquer outro sufixo @xxx
  return jid.replace(/@.*$/, "");
};

/**
 * Verifica se o JID é de um grupo
 * @param {string} jid - JID completo
 * @returns {boolean}
 */
export const isGroupJid = (jid) => {
  if (!jid) return false;
  return jid.includes("@g.us");
};

/**
 * Verifica se o JID é do tipo LID (Linked ID)
 * @param {string} jid - JID completo
 * @returns {boolean}
 */
export const isLidJid = (jid) => {
  if (!jid) return false;
  return jid.includes("@lid");
};

/**
 * Formata o número para exibição com máscara brasileira
 * @param {string} jid - JID completo ou número
 * @returns {string} - Número formatado (ex: "+55 (11) 99999-9999")
 */
export const formatPhoneNumberBrazil = (jid) => {
  const number = formatPhoneNumber(jid);

  if (!number || number.length < 10) return number;

  // Formato brasileiro: +55 (XX) XXXXX-XXXX
  if (number.length === 13 && number.startsWith("55")) {
    return `+${number.slice(0, 2)} (${number.slice(2, 4)}) ${number.slice(4, 9)}-${number.slice(9)}`;
  }

  // Formato brasileiro sem +55: (XX) XXXXX-XXXX
  if (number.length === 11) {
    return `(${number.slice(0, 2)}) ${number.slice(2, 7)}-${number.slice(7)}`;
  }

  return number;
};

export default formatPhoneNumber;
